module.exports = __webpack_public_path__ + "img/company16.107d9a52.png";